export default {
  cardPack: 'Card pack',
  cardsSuffix: ' cards',
  cardPower: 'Card power',
  cardPowerValue: '{0} card power',
  cardPowerDescription: 'Card power is added for all active cards and increases basic stats of that feature',
  notFound: 'No cards found',
  fullCollectionReward: 'Full collection reward',
  canFind: 'This card can be found in the following packs',
  cannotFind: 'This card cannot be found in your currently available packs',
  active: 'Active cards',
  equipped: 'cards equipped',
  onActive: 'when active',
  onDuplicate: 'on duplicate',
  activeDescription: 'Duplicate cards can be equipped, and will be consumed on next prestige to activate their effects. These effects stay active until you prestige again.',
  shinyTitle: 'Shiny cards',
  shinyDescription: 'Cards from card packs have a {0}% chance to be shiny. Shiny cards give +1 card power to that card forever, and also increase prestige income for that feature.',
  sort: {
    number: 'Card number',
    power: 'Highest power',
    owned: 'Most owned',
  },
  equipTutorial: {
    description: 'You collected your first cards! Most cards have an effect when active, to enable it you have to do the following:',
    1: 'Collect a duplicate of a card',
    2: 'Unlock prestige for one of your main features',
    3: 'Go to the prestige menu and equip the duplicate card (must be the same feature as seen at the bottom right of the card)',
    4: 'Perform a prestige with the card equipped',
    5: 'The card will get consumed and its effects are active until you prestige again'
  },
  card: {
    'MI-0001': 'Basic equipment',
    'MI-0002': 'Unused pickaxe',
    'MI-0003': 'Pickaxe crate',
    'MI-0004': 'Light the fuse!',
    'MI-0005': 'Into the depths',
    'MI-0006': 'Helmet shelf',
    'MI-0007': 'Take cover!',
    'MI-0008': 'Working hard',
    'MI-0009': 'Pick or shovel?',
    'MI-0010': 'Too small',
    'MI-0011': 'Motivated worker',
    'MI-0012': 'Workplace accident',
    'MI-0013': 'Temporary storage',
    'MI-0014': 'Filled crate',
    'MI-0015': 'To the surface',
    'MI-0016': 'Extraction',
    'MI-0017': 'Transport',
    'MI-0018': 'Quality control',
    'MI-0019': 'Recycling factory',
    'MI-0020': 'Hydraulic press',
    'MI-0021': 'Refining experiment',
    'MI-0022': 'Robot assembly',
    'MI-0023': 'Stuck pickaxe',
    'MI-0024': 'Mine entrance',
    'MI-0025': 'Detonate rock pile',
    'MI-0026': 'Mineshaft',
    'MI-0027': 'Surface rock',
    'MI-0028': 'Disturbing the bats',
    'MI-0029': 'Creepy crawly',
    'MI-0030': 'Rare find',
    'MI-0031': 'Underground lake',
    'MI-0032': 'Flammable liquid',
    'MI-0033': 'Underground cemetery',
    'MI-0034': 'Lurking spider',
    'MI-0035': 'No way out',
    'MI-0036': 'Earthquake',
    'MI-0037': 'Toxic gas',
    'MI-0038': 'Crystal spikes',
    'MI-0039': 'Pickaxe',
    'MI-0040': 'Shovel',
    'MI-0041': 'Crystal',
    'MI-0042': 'Bottle',
    'MI-0043': 'Cave',
    'MI-0044': 'Fire',
    'MI-0045': 'Tree',
    'MI-0046': 'Lightbulb',
    'MI-0047': 'Mossy stone',
    'MI-0048': 'Banana plant',
    'MI-0049': 'Cave root',
    'MI-0050': 'Strange mushrooms',
    'MI-0051': 'Seed crates',
    'MI-0052': 'Fire flower',
    'MI-0053': 'Glowing fern',
    'MI-0054': 'Tree of life',
    'MI-0055': 'Double-sided pickaxe',
    'MI-0056': 'Crystal cave',
    'MI-0057': 'Nitro',
    'MI-0058': 'Multi-storage',
    'MI-0059': 'Brick wall',

    'VI-0001': 'Massive boulders',
    'VI-0002': 'Hidden gem',
    'VI-0003': 'Dripstone cave',
    'VI-0004': 'Two paths',
    'VI-0005': 'Cave flowers',
    'VI-0006': 'Outside camping',
    'VI-0007': 'Playground',
    'VI-0008': 'Quiet area',
    'VI-0009': 'Angry neighbor',
    'VI-0010': 'House with garden',
    'VI-0011': 'Build a home',
    'VI-0012': 'Camping trip',
    'VI-0013': 'Living room',
    'VI-0014': 'Dog house',
    'VI-0015': 'Roof garden',
    'VI-0016': 'Century tree',
    'VI-0017': 'Tree theft',
    'VI-0018': 'Community garden',
    'VI-0019': 'Reforesting',
    'VI-0020': 'Deforesting',
    'VI-0021': 'Log truck',
    'VI-0022': 'Research lab',
    'VI-0023': 'Experiment',
    'VI-0024': 'Disease analysis',
    'VI-0025': 'Forming bars',
    'VI-0026': 'Nail factory',
    'VI-0027': 'Old library',
    'VI-0028': 'Clockwork',
    'VI-0029': 'Cooking robot',
    'VI-0030': 'Remote garage',
    'VI-0031': 'Generator',
    'VI-0032': 'Solar panels',
    'VI-0033': 'Self-driving car',
    'VI-0034': 'Firefighters',
    'VI-0035': 'Police station',
    'VI-0036': 'Lighting the way',
    'VI-0037': 'Saving a dog',
    'VI-0038': 'Ambulance',
    'VI-0039': 'Lifeguard',
    'VI-0040': 'Sale',
    'VI-0041': 'Abandoned factory',
    'VI-0042': 'Skyscraper',
    'VI-0043': 'Furniture store',
    'VI-0044': 'Toolsmith',
    'VI-0045': 'Portable generator',
    'VI-0046': 'Air filter',
    'VI-0047': 'Oil tanker',
    'VI-0048': 'Tax investigation',
    'VI-0049': 'Luxury mansion',
    'VI-0050': 'Green meadow',
    'VI-0051': 'Miracle',
    'VI-0052': 'Renewable energy',
    'VI-0053': 'Coin collector',
    'VI-0054': 'Builders and tools',
    'VI-0055': 'Recruitment agency',
    'VI-0056': 'Book sale',
    'VI-0057': 'Tipping jar',
    'VI-0058': 'Rug',
    'VI-0059': 'Self-made millionaire',
    'VI-0060': 'Well-kept garden',
    'VI-0061': 'Engagement rings',
    'VI-0062': 'Workbench',
    'VI-0063': 'Protest',
    'VI-0064': 'Environmental disaster',

    'HO-0001': 'Lurking snake',
    'HO-0002': 'Deep hole',
    'HO-0003': 'Erupting volcano',
    'HO-0004': 'Lost',
    'HO-0005': 'Frozen forever',
    'HO-0006': 'Magma chamber',
    'HO-0007': 'Backpack check',
    'HO-0008': 'Wall construction',
    'HO-0009': 'Surveillance camera',
    'HO-0010': 'Mushroom guide',
    'HO-0011': 'Electric fence',
    'HO-0012': 'Megabomb',
    'HO-0013': 'Rocket launcher',
    'HO-0014': 'Sworderang',
    'HO-0015': 'Poisoned arrow',
    'HO-0016': 'Guided missile',
    'HO-0017': 'Axe thrower',
    'HO-0018': 'Mighty pen',
    'HO-0019': 'Catapult',
    'HO-0020': 'Gunblade',
    'HO-0021': 'Sun rays',
    'HO-0022': 'Sawblade launcher',
    'HO-0023': 'Supercorrosive',
    'HO-0024': 'Natural cover',
    'HO-0025': 'Forest meditation',
    'HO-0026': 'Metal detector',
    'HO-0027': 'Projectile shield',
    'HO-0028': 'Force field',
    'HO-0029': 'Radar',
    'HO-0030': 'Spy',
    'HO-0031': 'Corruption not allowed',
    'HO-0032': 'Liquid filter',
    'HO-0033': 'Washing machine',
    'HO-0034': 'Kill it with fire',
    'HO-0035': 'Purification beam',
    'HO-0036': 'Stomp the corruption',
    'HO-0037': 'Into the trash!',
    'HO-0038': 'Glowing corruption',
    'HO-0039': 'Vacuum cleaner',
    'HO-0040': 'Power of science',
    'HO-0041': 'Corrupted weapons',
    'HO-0042': 'Strange ritual',
    'HO-0043': 'Just microwave it',
    'HO-0044': 'Ninja',
    'HO-0045': 'Karate fighter',
    'HO-0046': 'Zen meditation',
    'HO-0047': 'Strategy tent',
    'HO-0048': 'Phalanx',
    'HO-0049': 'Guillotine',
    'HO-0050': 'Jagged knife',
    'HO-0051': 'Blood container',
    'HO-0052': 'Lift and study',
    'HO-0053': 'Potion shelf',
    'HO-0054': 'Pawn shop',
    'HO-0055': 'Man and machine',
    'HO-0056': 'Weightlifting competition',
    'HO-0057': 'Scrolls',
    'HO-0058': 'Bullseye!',
    'HO-0059': 'Cavalry',
    'HO-0060': 'Marathon',
    'HO-0061': 'Elemental orbs',
    'HO-0062': 'Shortcut',
    'HO-0063': 'Robotic arms',
    'HO-0064': 'World champion',
    'HO-0065': 'Loot magnet',

    'FA-0001': 'Picking apples',
    'FA-0002': 'Pumpkin contest',
    'FA-0003': 'Flower shop',
    'FA-0004': 'Office plant',
    'FA-0005': 'Scarecrow',
    'FA-0006': 'Artificial rain',
    'FA-0007': 'Supply train',
    'FA-0008': 'Food transport',
    'FA-0009': 'Warm greenhouse',
    'FA-0010': 'Fruit smoothie',
    'FA-0011': 'Bakery sale',
    'FA-0012': 'Ice cream truck',
    'FA-0013': 'Fast food order',
    'FA-0014': 'Feast',
    'FA-0015': 'Candyland',
    'FA-0016': 'Tea time',
    'FA-0017': 'Making wine',
    'FA-0018': 'Cookie and coffee',
    'FA-0019': 'Orange veggies',
    'FA-0020': 'Spicy-fruity red',
    'FA-0021': 'Daisy yellow',
    'FA-0022': 'Plant green',
    'FA-0023': 'Blueberry bush',
    'FA-0024': 'Purple mushrooms',
    'FA-0025': 'Bug powder',
    'FA-0026': 'Fresh lime',
    'FA-0027': 'Butterfly wings',
    'FA-0028': 'Fertile soil',
    'FA-0029': 'Thunderstorm',
    'FA-0030': 'Salted earth',
    'FA-0031': 'Scorched earth',
    'FA-0032': 'Barn',
    'FA-0033': 'Vegetable soup',
    'FA-0034': 'Berry juice',
    'FA-0035': 'Wheat field',
    'FA-0036': 'Huge sunflower',
    'FA-0037': 'Gnome collection',
    'FA-0038': 'Beekeeper',
    'FA-0039': 'Silo',
    'FA-0040': 'Flower meadow',
    'FA-0041': 'Caring farmer',
    'FA-0042': 'Collecting seeds',
    'FA-0043': 'Finding bugs',
    'FA-0044': 'Seed colony',
    'FA-0045': 'Giantroot',
    'FA-0046': 'Black roses',
    'FA-0047': 'Lawnmower robot',
    'FA-0048': 'Shimmergrain',
    'FA-0049': 'Powerberry',

    'GA-0001': 'Ladybugs',
    'GA-0002': 'Colorful feathers',
    'GA-0003': 'Making lemonade',
    'GA-0004': 'Algae',
    'GA-0005': 'Art museum',
    'GA-0006': 'Pencil drawing',
    'GA-0007': 'Pen collection',
    'GA-0008': 'Spray painting',
    'GA-0009': 'Color palette',
    'GA-0010': 'Wall painting',
    'GA-0011': 'Artist signature',
    'GA-0012': 'Mixing paint',
    'GA-0013': 'Modern art auction',
    'GA-0014': 'Portrait',
    'GA-0015': 'Recycling bin',
    'GA-0016': 'Pizza delivery',
    'GA-0017': 'Package delivery',
    'GA-0018': 'School bus',
    'GA-0019': 'Drum factory',
    'GA-0020': 'Cargo ship',
    'GA-0021': 'Moving company',
    'GA-0022': 'Drone delivery',
    'GA-0023': 'Tow truck',
    'GA-0024': 'Car',
    'GA-0025': 'Face',
    'GA-0026': 'Water',
    'GA-0027': 'Flower',
    'GA-0028': 'House',
    'GA-0029': 'Fire arrow',
    'GA-0030': 'Golden sword',
    'GA-0031': 'Photographer',
    'GA-0032': 'Inspiring banner',
    'GA-0033': 'Ship in a bottle',
    'GA-0034': 'Knitted sweater',
    'GA-0035': 'Crafting furniture',
    'GA-0036': 'Woodcarving',
    'GA-0037': 'Bonsai tree',
    'GA-0038': 'Painting figures',
    'GA-0039': 'Confusion',
    'GA-0040': 'Rusty drum',

    'GE-0001': 'Ruby railway',
    'GE-0002': 'Emerald mine',
    'GE-0003': 'Sunken treasure',
    'GE-0004': 'Luxury watch',
    'GE-0005': 'Dangerous triangles',
    'GE-0006': 'Diamond tools',
    'GE-0007': 'Security measures',

    'EV-0001': 'Fair',
    'EV-0002': 'Building competition',
    'EV-0003': 'Grill',
    'EV-0004': 'Birthday party',
    'EV-0005': 'Yard sale',
    'EV-0006': 'Gas station',
    'EV-0007': 'Local merchant',
    'EV-0008': 'Bingo on TV',
    'EV-0009': 'Casino',
    'EV-0010': '???',
    'EV-0011': 'Bank safe',
    'EV-0012': 'Profit!',
    'EV-0013': 'Credit card',
    'EV-0014': 'Desert',
    'EV-0015': 'Paragliding',
    'EV-0016': 'Jungle mystery',
    'EV-0017': 'Stranded turtle',
    'EV-0018': 'Flower breeding',
    'EV-0019': 'Plant sample',
    'EV-0020': 'Spearfishing',
    'EV-0021': 'Snail race',
    'EV-0022': 'Lonely island',
    'EV-0023': 'Summer song',
    'EV-0024': 'Cozy couch',
    'EV-0025': 'Nasty mountain',
    'EV-0026': 'Nighttime city',
    'EV-0027': 'Hot apple juice',
    'EV-0028': 'Mysterious soup',
    'EV-0029': 'Secret spring',
    'EV-0030': 'Build a snowman',
    'EV-0031': 'Winter sports',
    'EV-0032': 'Castle lights',
    'EV-0033': 'Lightbulb store',

    'XD-1337': 'Testing card',
  },
  collection: {
    minersAndEquipment: 'Miners and equipment',
    scrapLogistics: 'Scrap logistics',
    caveLocations: 'Cave locations',
    dangersInTheDark: 'Dangers in the dark',
    versatile: 'Versatile',
    neighborhood: 'Neighborhood',
    plantsInTheCity: 'Plants in the city',
    industrialRevolution: 'Industrial revolution',
    maintainingSafety: 'Maintaining safety',
    localBusiness: 'Local business',
    dangerousWeapons: 'Dangerous weapons',
    supplyAndSupport: 'Supply and support',
    againstTheCorruption: 'Against the corruption',
    artOfWar: 'Art of war',
    skillfulCombat: 'Skillful combat',
    feedingTheWorld: 'Feeding the world',
    organicDyes: 'Organic dyes',
    countryLife: 'Country life',
    forgottenPlants: 'Forgotten plants',
    artDisplay: 'Art display',
    deliveryService: 'Delivery service',
    abstractShapes: 'Abstract shapes',
    handmade: 'Handmade',
    preciousJewelry: 'Precious jewelry',
    weekendTrip: 'Weekend trip',
    tropicalParadise: 'Tropical paradise',
    coldTimes: 'Cold times',
    specialGadgets: 'Special gadgets',
  },
  pack: {
    intoDarkness: 'Into darkness',
    drillsAndDepths: 'Drills and depths',
    hotStuff: 'Hot stuff',
    dangerZone: 'Danger zone',
    cloudsAndSmoke: 'Clouds and smoke',
    deepHole: 'Deep hole',
    blackDust: 'Black dust',
    meetingNewPeople: 'Meeting new people',
    darkCult: 'Dark cult',
    technologicalAdvancement: 'Technological advancement',
    wasteDisposal: 'Waste disposal',
    settingUpShop: 'Setting up shop',
    merchantUnion: 'Merchant union',
    rookieOnTheBattlefield: 'Rookie on the battlefield',
    spiritualSuccess: 'Spiritual success',
    oldMemories: 'Old memories',
    taintedWorld: 'Tainted world',
    towerOfPower: 'Tower of power',
    learnToFight: 'Learn to fight',
    combatExpert: 'Combat expert',
    bountifulHarvest: 'Bountiful harvest',
    juicyYields: 'Juicy yields',
    insectWorld: 'Insect world',
    beesAndFlowers: 'Bees and flowers',
    strongPlants: 'Strong plants',
    seedVariety: 'Seed variety',
    newArtist: 'New artist',
    inspiringCreations: 'Inspiring creations',
    differentColors: 'Different colors',
    bigCanvas: 'Big canvas',
    famousPainter: 'Famous painter',
    goodDeal: 'Good deal',
    connectedLine: 'Connected line',
    feelingLucky: 'Feeling lucky',
    investorsDream: 'Investors dream',
    greenThumb: 'Green thumb',
    fishingForFun: 'Fishing for fun',
    charmingShip: 'Charming ship',
    midnightAnomaly: 'Midnight anomaly',
    icyWonderland: 'Icy wonderland',
    sparksOfJoy: 'Sparks of joy',
  }
};
